<div *ngIf="requisitionInfo && requisitionInfo.hiringManagerDetails">
    <h2 class="text-center  requisition-card-recruiter-heading"
        [ngClass]="{'purple':requisitionInfo.sharedRequisition, 'emerald':!requisitionInfo.sharedRequisition}">
        Hiring Managers
    </h2>
    <div class="row requisition-card-hiring-managers-popover-content-container">
        <div class="text-center recruiter-item"
            [ngClass]="{'col-xs-12':requisitionInfo.hiringManagerDetails.length==1,
            'col-xs-6':requisitionInfo.hiringManagerDetails.length<3,
            'col-xs-3':requisitionInfo.hiringManagerDetails.length>=3 }"
            style="flex-grow: 1;"
            *ngFor="let hiringManager of requisitionInfo.hiringManagerDetails; trackBy: trackByIndex"
            [hidden]="hiringManager.isPrimary"
            [tooltip]="hiringManager.name">
            <img src="assets/app-content/img/people/4dot5-default-no-profile-pic.jpg" [alt]="hiringManager.name"
                [ngClass]="{'requisition-card-recruiter-img-other': requisitionInfo.sharedRequisition && !isCorporateCompany}"
                class="requisition-card-hiring-manager-img img-responsive" />
            <span class="requisition-card-hiring-manager-name">{{hiringManager.name}}</span>
        </div>
    </div>
</div>
